const ageNumber = (team) => {
  const match = String(team?.age_group || team?.team_name || '').match(/U(\d+)/i);
  return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
};

const nameForSort = (team) => String(team?.team_name || '')
  .replace(/\bU\d+s?\b/gi, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export const compareAcademyTeams = (a, b) => {
  const byAge = ageNumber(a) - ageNumber(b);
  if (byAge !== 0) {
    return byAge;
  }
  return nameForSort(a).localeCompare(nameForSort(b), 'en', { sensitivity: 'base', numeric: true });
};

const firstCount = (...values) => {
  for (let i = 0; i < values.length; i += 1) {
    if (values[i] != null && values[i] !== '') {
      return Number(values[i]) || 0;
    }
  }
  return null;
};

export const withTeamUsage = (teams, usageTeams) => {
  const byId = new Map();
  (usageTeams || []).forEach((team) => {
    const id = Number(team.team_id);
    if (id) {
      byId.set(id, team);
    }
  });
  return (teams || []).map((team) => {
    const usage = byId.get(Number(team.team_id));
    const playerCount = firstCount(team.player_count, usage?.player_count, usage?.team_length);
    const parentCount = firstCount(team.parent_count, usage?.parent_count);
    return {
      ...team,
      ...(playerCount != null ? { player_count: playerCount } : {}),
      ...(parentCount != null ? { parent_count: parentCount } : {}),
    };
  });
};

export const loadAcademyDirectory = async (api) => {
  const [directoryRes, usageRes] = await Promise.all([
    api.get('/get_teams_directory.php?include_usage=1'),
    api.get('/fetch_all_teams.php').catch(() => ({ data: {} })),
  ]);
  return withTeamUsage(directoryRes.data.teams || [], usageRes.data?.teams || []);
};
